import React, { memo } from 'react'

import { OptionTemplate } from './OptionTemplate'
import { BaseOptionType, IOptionProps } from './types'

const OptionNoMemo = <Option extends BaseOptionType>(props: IOptionProps<Option>) => (
  <OptionTemplate {...props}>{props.name}</OptionTemplate>
)

export const Option = memo(OptionNoMemo) as typeof OptionNoMemo
